import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { NSDiversionsConstants } from '@ruby/configs/diversions.constants';
import {
  DiversionsReviewDetailsActions,
  DiversionsReviewDetailsSelectors,
  fromDiversionsReviewDetails
} from '@ruby/modules/diversions/store/diversions-review-details.index';
import { EDiversionsGridPaths } from '@ruby/shared/enums/diversions.enum';
import { IGridConfigurations } from '@ruby/shared/models/commons/grid.interface';
import { AppState } from '@ruby/store';

@Component({
  selector: 'ng-diversions-review-details-container',
  templateUrl: './diversions-review-details.container.html',
  styleUrls: ['./diversions-review-details.container.scss']
})
export class DiversionsReviewDetailsContainer {
  store$: Observable<fromDiversionsReviewDetails.State>;
  configs: IGridConfigurations = NSDiversionsConstants.gridPageConfigs[EDiversionsGridPaths.REVIEW];

  constructor(private store: Store<AppState>) {
    this.store$ = this.store.select(DiversionsReviewDetailsSelectors.selectDiversionsReviewDetailsState);
    this.dispatchLoadData();
  }

  /**
   * Dispatch Load Data
   *
   * @summary Dispatch the data source
   * @returns void
   */
  dispatchLoadData(): void {
    this.store.dispatch(DiversionsReviewDetailsActions.loadReviewsDetails());
  }
}
